.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: var(--tuna-spacing-1, 8px);
}

.tabs {
  flex-shrink: 0;
  border-bottom: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.empty {
  color: var(--tuna-palette-text-secondary);
  padding: var(--tuna-spacing-2, 16px);
}

/* Per-agent icon prefix on each tab. The decorative svg sits to the left
   of the label; the wrapping <Tab> sets its accessible name from `label`
   while we pass aria-hidden on the icon so screen readers don't double-read. */
.tabIcon {
  width: 16px;
  height: 16px;
  margin-right: var(--tuna-spacing-0_5, 4px);
  flex: 0 0 16px;
}
